// devplus data object
// import { settings } from './config.js';

export const devplus = {
    body: document.querySelector( 'body' ),
    html: document.querySelector( 'html' ),
    nav_toggler: document.querySelector( '.nav-toggler' ),
    adminbar: document.querySelector( '#wpadminbar' ),
    cookies_bar: document.querySelector( '#page-cookies' ),
    cookie_consent_given: false,
    cookie_consent_name: 'nsz_cookie_consent',
};

// openklappen navigatie
export function nav_toggler() {

    const nav_open = document.querySelector( '.open-nav' );
    const nav_close = document.querySelectorAll( '.close-nav' );

    if ( nav_open ) {

        nav_open.addEventListener( 'click', ( e ) => {

            e.preventDefault();

            devplus.body.classList.add( 'nav-open' );

        } );

    }

    if ( nav_close.length ) {

        nav_close.forEach( item => {

            item.addEventListener( 'click', ( e ) => {

                e.preventDefault();

                devplus.body.classList.remove( 'nav-open' );

            } );

        } );

    }

}